import React from 'react';
import * as UserCardUI from './UserCardUI';
import { ICreatorFieldsFragment } from '../../utils/apollo/graphqlSchema';

type UserCardSize = 'small' | 'large';

interface IUserCardSizeConfig {
  avatarSize: number;
  nameSize: number;
  lineHeight: number;
  gap: number;
}

interface IProps {
  user: ICreatorFieldsFragment;
  size: UserCardSize;
  className?: string;
  label?: string;
}

const userCardSizes: Record<UserCardSize, IUserCardSizeConfig> = {
  large: {
    avatarSize: 20,
    nameSize: 14,
    lineHeight: 20,
    gap: 8,
  },
  small: {
    avatarSize: 16,
    nameSize: 10,
    lineHeight: 16,
    gap: 6,
  },
};

export default ({ user, size, className, label }: IProps) => {
  const { avatarSize, nameSize, lineHeight, gap } = userCardSizes[size];

  return (
    <UserCardUI.Container className={className}>
      <UserCardUI.UserAvatar
        picture={user.picture}
        size={avatarSize}
        $gap={gap}
      />
      <UserCardUI.Text $size={nameSize} $lineHeight={lineHeight}>
        <UserCardUI.Name>{user.name}</UserCardUI.Name>
        {label && (
          <>
            <UserCardUI.LabeledDivider />
            {label}
          </>
        )}
      </UserCardUI.Text>
    </UserCardUI.Container>
  );
};
